import React from "react";

import { useTranslation } from "react-i18next";
import { FrontendTempFilePasswordManagement } from "node-library/dist/portal";
import UserCell from "./filePasswordCell";
import FilePasswordCell from "./filePasswordCell";

interface Props {
	filePasswords: Array<FrontendTempFilePasswordManagement>;
	goToViewFileDetails: (file: FrontendTempFilePasswordManagement) => void;
}

export default function ViewFilePasswordsTable(props: Props) {
	const { t: translation } = useTranslation();

	const { filePasswords, goToViewFileDetails } = props;

	const filePasswordCells: Array<React.ReactNode> = filePasswords
		? filePasswords.map(
				(filePassword: FrontendTempFilePasswordManagement, index: number) => {
					return (
						<FilePasswordCell
							key={filePassword.id}
							filePassword={filePassword}
							goToViewFileDetails={() => goToViewFileDetails(filePassword)}

							// discardUnstartedOrder={() => {
							// 	setProceedAction(() => () => discardUnstartedOrder(order));
							// 	setDiscardOrderConfirmOpen(true);
							// }}
						/>
					);
				}
		  )
		: [];

	return <div className="view-order-grid-table">{filePasswordCells}</div>;
}
